/*
 * Author M. Atoar Rahman
 * Title: Outer Agency
 * Description: Page for Outer Agency
 * Date: 15/03/2022
 */

import React from 'react';
import { Card } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';
import { OuterAgencyProvider } from '../masterSetup/outerAgency/ContextAPI';
import DataTable from '../masterSetup/outerAgency/DataTable';
import FormInfo from '../masterSetup/outerAgency/FormInfo';
import PermissionDenied from './PermissionDenied';

export default function OuterAgency() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['outer-agencies']) return <PermissionDenied />;

    return (
        <OuterAgencyProvider>
            <Card>
                <Card.Header className="cardHeader">
                    <h3>Outer Agencies</h3>
                    <div>
                        <FormInfo />
                    </div>
                </Card.Header>
                <Card.Body>
                    <DataTable />
                </Card.Body>
            </Card>
        </OuterAgencyProvider>
    );
}
